export const StorageKeys = {
  TOKEN: 'ROCP_token',
  LOGIN_IN_PROGRESS: 'ROCP_loginInProgress',
  LAST_PATHNAME: 'lastPathname',
  CI: 'ROCP_ci',
  // sessionStorage: one object of EUP-only preferences ({ locale, ... }) so
  // new ones can be added without minting more storage keys.
  EUP_REFERENCE: 'eupReference',
  // Custom font config cached across sessions so returning users paint the
  // modal in the correct font on first render — no visible Lato→CustomFont
  // swap while the API resolves and the file downloads. Two entries because
  // the two centers are scoped differently: the collector serves many consent
  // profiles from one origin (a map keyed by consentProfileId), while
  // privacy-center serves the one authenticated principal (a single record).
  CONSENT_CUSTOM_FONT: 'consent_custom_font',
  PRIVACY_CENTER_CUSTOM_FONT: 'privacy_center_custom_font',
};
